<template>
  <div>
    <please-wait-modal/>
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">{{ this.$route.query.id != null ? 'Edit' : 'Add' }} Voucher</h1>
    </div>
    <div class="row">
      <div class="col-12 col-md-4 d-none d-md-block">
        <ul class="list-group">
          <li class="list-group-item p-5">
            <div class="ratio_169" :style="{'backgroundImage':'url('+picture+')'}" style="background-repeat: no-repeat; background-size: contain;"></div>
            <input type="file" name="photo" accept="image/*" class="d-none" id="file_input" @change="display_image">
            <a name="uploadPhoto" id="uploadPhoto" class="btn btn-outline-primary mt-4 btn-block btn-sm" href="#!" role="button" onclick="$('#file_input').trigger('click')">Upload Photo</a>
          </li>
        </ul>
      </div>
      <div class="col-12 col-md-8">
        <publish-web
          :data_media_type="media_type"
          :data_is_publish="is_publish"
          @on-media-type-changed="change_media_type"
          @on-publish-status-changed="change_publish_status"/>
        <div class="form-group">
          <div class="row px-3">
            <label for="#form-name" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Code</label>
            <input class="form-control col-lg-8" id="form-name" v-model="code"/>
          </div>
        </div>
        <div class="form-group">
          <div class="row px-3">
            <label for="#form-name" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Name</label>
            <input class="form-control col-lg-8" id="form-name" v-model="name"/>
          </div>
        </div>
        <div class="form-group">
          <div class="row px-3">
            <label for="#form-name" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Description</label>
            <textarea class="form-control col-lg-8" v-model="description"></textarea>
          </div>
        </div>
        <div class="form-group">
          <div class="row px-3">
            <label for="#form-title" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Quantity Type</label>
            <select class="form-control col-lg-8" v-model="quantity_type">
              <option value="unlimited">Unlimited</option>
              <option value="limited">Limited</option>
            </select>
          </div>
        </div>
        <div class="form-group" v-show="quantity_type == 'limited'">
          <div class="row px-3">
            <label for="#form-title" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Total</label>
            <input class="form-control col-lg-8" id="form-name" v-model="total"/>
          </div>
        </div>
        <div class="form-group">
          <div class="row px-3">
            <label for="#form-title" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Start At</label>
            <v-date-picker v-model="start_at" :masks="masks" :max-date="expired_at != '' ? new Date(expired_at) : null" :min-date="now > start_at_moment ? new Date(start_at_moment) : new Date()"/>
          </div>
        </div>
        <div class="form-group">
          <div class="row px-3">
            <label for="#form-title" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Expired At</label>
            <v-date-picker v-model="expired_at" :masks="masks" :min-date="start_at != '' ? new Date(start_at) : new Date()"/>
          </div>
        </div>
        <div class="form-group">
          <div class="row px-3">
            <label for="#form-title" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Min Purchase</label>
            <input class="form-control col-lg-8" id="form-name" v-model="min_purchase"/>
          </div>
        </div>
        <div class="form-group">
          <div class="row px-3">
            <label for="#form-title" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Type</label>
            <select class="form-control col-lg-8" v-model="type">
              <option value="fixed">Fixed</option>
              <option value="percentage">Percentage</option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <div class="row px-3">
            <label for="#form-title" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Amount</label>
            <input class="form-control col-lg-8" id="form-name" v-model="amount"/>
          </div>
        </div>
        <div class="form-group" v-show="type == 'percentage'">
          <div class="row px-3">
            <label for="#form-title" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Max Discount</label>
            <input class="form-control col-lg-8" id="form-name" v-model="max_discount"/>
          </div>
        </div>
        <div class="form-group">
          <div class="row px-3">
            <label for="#form-title" class="col-lg-4 pl-0 m-0 d-flex align-items-center">User Type</label>
            <select class="form-control col-lg-8" v-model="user_type">
              <option value="new">New</option>
              <option value="old">Old</option>
              <option value="all">All</option>
            </select>
          </div>
        </div>
        <div class="form-group text-right">
          <a type="button" class="btn btn-danger" href="/voucher">Cancel</a>
          <button type="button" class="btn btn-primary" @click="save">Save</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import please_wait_modal from '@/layout/please_wait_modal'
import publish_web from '@/layout/publish_web'
import modal_edit from '@/pages/master/helper_sub_category/modal_edit_sub_sub_category'

export default {
  components:{
    'please-wait-modal': please_wait_modal,
    'publish-web': publish_web,
    'modal-edit': modal_edit,
  },
  data(){
    return{
      picture: '',
      is_change_photo: false,
      name: '',
      description: '',
      total: 0,
      start_at: '',
      start_at_moment: moment(),
      expired_at: '',
      expired_at_moment: moment(),
      user_type: '',
      min_purchase: 0,
      max_discount: 0,
      type: '',
      quantity_type: '',
      amount: 0,
      code: '',
      media_type: 'none',
      is_publish: '',
      now: moment(),
      masks: {
        input: 'DD/MM/YYYY', // Uses 'iso' if missing
      },
    }
  },
  watch:{
    total(val){
      this.total = val != '' ? parseFloat(val.replace(/\./g,'')).toLocaleString('id-ID') : '0'
    },
    min_purchase(val){
      this.min_purchase = val != '' ? parseFloat(val.replace(/\./g,'')).toLocaleString('id-ID') : '0'
    },
    max_discount(val){
      this.max_discount = val != '' ? parseFloat(val.replace(/\./g,'')).toLocaleString('id-ID') : '0'
    },
    amount(val){
      this.amount = val != '' ? parseFloat(val.replace(/\./g,'')).toLocaleString('id-ID') : '0'
    },
    code(val){
      this.code = val.replace(/[^a-zA-Z0-9]/g, '').replace(' ', '')
    }
  },
  async created(){
    if(this.$route.query.id != null){
      await this.get_data()
    }
  },
  methods:{
    change_media_type(val){
      this.media_type = val
    },
    change_publish_status(val){
      this.is_publish = val
      if(val == 0)
        this.media_type = "none"
    },
    async save(){
      try{
        if(this.name === '')
          this.$toasted.show('Name is empty')
        else if(this.$route.query.id == null && this.quantity_type === 'limited' && this.total === '0')
          this.$toasted.show('Total is empty')
        else if(this.start_at === '')
          this.$toasted.show('Start at is empty')
        else if(this.expired_at === '')
          this.$toasted.show('Expired at is empty')
        else if(this.min_purchase === '0')
          this.$toasted.show('Min Purchase is empty')
        else if(this.type === '')
          this.$toasted.show('Type is empty')
        else if(this.amount === '0')
          this.$toasted.show('Amount is empty')
        else if(this.type === 'percentage' && this.max_discount === '0')
          this.$toasted.show('Max Discount is empty')
        else if(this.type === 'fixed' && parseFloat(this.min_purchase.replace(/\./g,'')) < parseFloat(this.amount.replace(/\./g,'')))
          this.$toasted.show('Min purchase is lower than amount')
        else if(this.is_publish === '')
          this.$toasted.show('Publish status is empty')
        else if(this.is_publish === 1 && (this.media_type === 'none' || this.media_type === ''))
          this.$toasted.show('Publish media is empty')
        else{
          $('#please_wait_modal').modal('show')
          var data = {}
          if(this.$route.query.id != null)
            data.id = this.$route.query.id
          if(this.is_change_photo)
            data.image = {
              original_rotation: 0,
              image: await image2base64(this.picture)
            }

          data.code = this.code
          data.name = this.name
          data.description = this.description
          data.quantity_type = this.quantity_type
          data.total = !Number.isInteger(this.total) ? parseFloat(this.total.replace(/\./g,'')) : this.total
          data.start_at = moment(this.start_at).format('YYYY-MM-DD')
          data.expired_at = moment(this.expired_at).format('YYYY-MM-DD')
          data.type = this.type
          data.user_type = this.user_type
          data.min_purchase = !Number.isInteger(this.min_purchase) ? parseFloat(this.min_purchase.replace(/\./g,'')) : this.min_purchase
          data.max_discount = !Number.isInteger(this.max_discount) ? parseFloat(this.max_discount.replace(/\./g,'')) : this.max_discount
          data.amount = !Number.isInteger(this.amount) ? parseFloat(this.amount.replace(/\./g,'')) : this.amount
          data.media_type = this.media_type
          data.is_publish = this.is_publish


          if(this.$route.query.id == null)
            var response = await axios.post(base_url+'/voucher',data)
          else
            var response = await axios.put(base_url+'/voucher',data)

          $('#please_wait_modal').modal('hide')
          var response_data = response.data
          if(response_data.status == "success"){
            location.href = '/voucher'
          }
          else
            this.$toasted.show(response_data.message)
        }
      } catch(e){
        $('#please_wait_modal').modal('hide')
        this.$toasted.show(e.message)
      }
    },
    async get_data(){
      try{
        var response = await axios.get(base_url+'/voucher?id='+this.$route.query.id)

        var response_data = response.data
        if(response_data.status == "success"){
          this.name = response_data.data.name
          this.code = response_data.data.code
          this.quantity_type = response_data.data.quantity_type
          this.description = response_data.data.description
          this.min_purchase = parseFloat(response_data.data.min_purchase).toLocaleString('id-ID')
          this.max_discount = parseFloat(response_data.data.max_discount).toLocaleString('id-ID')
          this.amount = parseFloat(response_data.data.amount).toLocaleString('id-ID')
          this.type = response_data.data.type
          this.user_type = response_data.data.user_type
          this.start_at_moment = moment(response_data.data.start_at)
          this.expired_at_moment = moment(response_data.data.expired_at)
          this.start_at = new Date(this.start_at_moment)
          this.expired_at = new Date(this.expired_at_moment)
          // console.log(this.start_at)
          this.total = parseFloat(response_data.data.total).toLocaleString('id-ID')
          this.picture = base_url+'/images/voucher?file_name='+response_data.data.file_name
          this.is_change_photo = false
          this.media_type = response_data.data.media_type
          this.is_publish = response_data.data.is_publish
        }
      } catch(e) {
        this.$toasted.show(e.message)
      }
    },
    display_image(event){
      // console.log(event.target.files[0].size)
      if(event.target.files[0].size > 1024 * 1024 * 5)
        this.$toasted.show('Your file size exceed 5 MB')
      this.picture = URL.createObjectURL(event.target.files[0])
      this.data_photo = event.target.files[0]
      this.is_change_photo = true
    },
  }
}
</script>
